import type { Delta } from 'quill/core';
import Quill from 'quill/core';
import Header from 'quill/formats/header';
import { useEffect, useState } from 'react';
import { useQuill } from '../editor/QuillContext';
import isInlineTextInsertion from '../editor/utils/isInlineTextInsertion';

export const useHasHeadings = () => {
  const { quill } = useQuill();

  const [hasHeadings, setHasHeadings] = useState<boolean | undefined>(
    undefined,
  );

  useEffect(() => {
    if (!quill) {
      return undefined;
    }

    const updateHasHeadings = (delta: Delta) => {
      if (!isInlineTextInsertion(delta)) {
        setHasHeadings(quill.scroll.descendants(Header).length > 0);
      }
    };

    setHasHeadings(quill.scroll.descendants(Header).length > 0);

    quill.on(Quill.events.TEXT_CHANGE, updateHasHeadings);

    return () => {
      quill.off(Quill.events.TEXT_CHANGE, updateHasHeadings);
    };
  }, [quill]);

  return hasHeadings;
};
